import './index.less';



// WEBPACK FOOTER //
// ./ecology9/wea-loading-global/style/index.js